// DS: ???
// from Zeplin
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const Hidden: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 36">
      <path
        fillRule="evenodd"
        d="M29.54 26.395l-3.497-4.208c.987-1.133 1.598-2.59 1.598-4.2 0-3.556-2.877-6.438-6.562-6.438-1.171 0-2.245.317-3.187.827L14.871 8.74c1.8-.8 3.843-1.308 6.129-1.308 9.098 0 14.327 8 15.873 10.795-.968 1.764-3.391 5.582-7.334 8.168M21 29.01c-9.093 0-14.32-7.993-15.87-10.79.984-1.771 3.44-5.618 7.415-8.206l3.355 4.037c-.859 1.092-1.384 2.444-1.384 3.935 0 3.554 2.877 6.456 6.563 6.456 1.05 0 2.021-.255 2.89-.675l3.244 3.904A14.992 14.992 0 0 1 21 29.012m20.577-9.84l.423-.95-.423-.95C41.317 16.675 34.991 2.77 21 2.77c-3.56 0-6.618.904-9.211 2.258L7.609 0 5.576 1.625 9.54 6.399C3.49 10.563.6 16.875.423 17.271l-.423.95.423.95C.685 19.765 7.009 33.673 21 33.673c3.596 0 6.675-.927 9.287-2.3L34.133 36l2.034-1.627-3.638-4.378c6.003-4.164 8.875-10.427 9.048-10.823"
        opacity=".8"
      />
    </svg>
  </IconWrap>
);
Hidden.displayName = 'Hidden';

export default Hidden;
